import React, { memo, useEffect, useState } from "react"
import SwapPage from "../components/SwapPage"
import SwapForm from "../forms/SwapForm"
import Container from "../components/Container"
import { useSearchParams } from "react-router-dom"
import useMigration from "hooks/useMigration"
import {
  CW20_WEBSITE,
  SWAP_PAGE_HEADING,
  SWAP_PAGE_SUB_HEADING,
  STAKE_FACTORY_ADDR,
  CW20_SYMBOL,
} from "constants/constants"

export enum Type {
  "SWAP" = "swap",
  "PROVIDE" = "provide",
  "WITHDRAW" = "withdraw",
}

const Swap = () => {
  const { isMigrationPage } = useMigration()
  const [searchParams, setSearchParams] = useSearchParams()
  let [month_apr, setMonth_Apr] = useState(0)
  let [year_apy, setYear_Apy] = useState(0)
  let [biWeek_apr, setBiWeek_Apr] = useState(0)
  let [closePrice_30day, setClosePrice_30day] = useState(0)
  let [closePrice_15day, setClosePrice_15day] = useState(0)
  let [minBuy, setMinBuy] = useState(0)

  const type = searchParams.get("type") as Type
  const tabs = {
    tabs: [
      {
        name: Type.SWAP,
        title: `Buy & Vest (${minBuy} ${CW20_SYMBOL} Min)`,
      },
    ],
    selectedTabName: isMigrationPage ? "migration" : type,
  }

  const handleCurrentPriceChange = (currentPrice: number) => {
    // Do something with the currentPrice in the parent component
    console.log("Updated currentPrice in parent:", currentPrice)

    if (currentPrice !== 0) {
      const calculatedMonthApr = (currentPrice / closePrice_30day - 1) * 100
      const calculatedBiWeekApr = (currentPrice / closePrice_15day - 1) * 100

      setMonth_Apr(calculatedMonthApr)
      setBiWeek_Apr(calculatedBiWeekApr)

      let maxApr
      if (calculatedMonthApr > calculatedBiWeekApr) {
        maxApr = calculatedMonthApr
        setYear_Apy(maxApr * 12)
      } else {
        maxApr = calculatedBiWeekApr
        setYear_Apy(maxApr * 26)
      }
    }
  }

  const handleClosePriceChange_30day = (closePrice_30day: number) => {
    // Do something with the closePrice in the parent component
    console.log("Updated closePrice in parent:", closePrice_30day)
    setClosePrice_30day(closePrice_30day)
  }

  const handleClosePriceChange_15day = (closePrice_15day: number) => {
    // Do something with the closePrice in the parent component
    console.log("Updated closePrice in parent:", closePrice_15day)
    setClosePrice_15day(closePrice_15day)
  }

  useEffect(() => {
    const url1 = `https://terra-classic-lcd.publicnode.com/cosmwasm/wasm/v1/contract/${STAKE_FACTORY_ADDR}/smart/eyJnZXRfaW5mbyI6e319`
    fetch(url1)
      .then((response) => response.text())
      .then((text) => {
        console.log(text)
        const get_info = JSON.parse(text)
        setMinBuy(Number(get_info.data.min_stake) / 1000000)
      })

    return
  }, [])

  useEffect(() => {
    if (!isMigrationPage) {
      if (
        !type ||
        !Object.keys(Type)
          .map((key) => Type[key as keyof typeof Type])
          .includes(type)
      ) {
        searchParams.set("type", Type.SWAP)
        setSearchParams(searchParams, { replace: true })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type, isMigrationPage])

  return (
    <Container>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
          height: "60px",
          fontSize: "28px",
        }}
      >
        <h1>{SWAP_PAGE_HEADING}</h1>
        <a href={CW20_WEBSITE} className="main-header-navbar__nav__link">
          {SWAP_PAGE_SUB_HEADING}
        </a>
      </div>

      <br></br>

      <SwapPage
        onCurrentPriceChange={handleCurrentPriceChange}
        onClosePriceChange_30day={handleClosePriceChange_30day}
        onClosePriceChange_15day={handleClosePriceChange_15day}
      >
        <>{type && <SwapForm type={type} tabs={tabs} />}</>
      </SwapPage>
    </Container>
  )
}

export default memo(Swap)
